import {
  CampaignSortBy,
  CampaignStatus,
} from "~frontend/__generated__/graphql";

export type CampaignStatusLabel = {
  value: CampaignStatus;
  label: string;
};

export const CAMPAIGN_STATUSES: Readonly<CampaignStatusLabel[]> = [
  { value: CampaignStatus.Draft, label: "Draft" },
  { value: CampaignStatus.InitialSendReady, label: "Ready to Send" },
  { value: CampaignStatus.InitialSendScheduled, label: "Send Scheduled" },
  { value: CampaignStatus.InitialSendCanceling, label: "Canceling Send" },
  { value: CampaignStatus.InitialSendComplete, label: "Send Complete" },
  { value: CampaignStatus.InitialSendRunning, label: "Sending" },
  {
    value: CampaignStatus.RoiTestAutosendPending,
    label: "Waiting For ROI Test",
  },
  {
    value: CampaignStatus.PartialSendEvaluationPending,
    label: "Waiting for Partial Send Evaluation",
  },
  { value: CampaignStatus.Archived, label: "Archived" },
];

export const CAMPAIGN_SORTS = [
  {
    value: CampaignSortBy.CreatedAtDesc,
    label: "Created At, Newest First",
  },
  {
    value: CampaignSortBy.CreatedAtAsc,
    label: "Created At, Oldest First",
  },
  {
    value: CampaignSortBy.NameAsc,
    label: "Name, A-Z",
  },
  {
    value: CampaignSortBy.NameDesc,
    label: "Name, Z-A",
  },
] as const;
